import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';

export function SignInAccountantsWorldCredential({
  isLoading,
  onSubmit,
  provider,
}: RegisterImplementationProps) {
  return (
    <SignInBase
      formLabel={`${provider.displayName} Sign In Form`}
      onSubmit={onSubmit}
      fieldNames={['firmCode', 'username', 'password']}
      render={({ firmCode, username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Input
                value={firmCode.value}
                onChange={(event) => firmCode.onChange(event.target.value)}
                invalid={firmCode.invalid}
                label="Firm Code"
                id="firmCode"
              />
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="User Name"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://login.accountantsoffice.com/forgot-password'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={isLoading || !firmCode.value || !username.value || !password.value}
              type="submit"
            />
          </>
        );
      }}
    />
  );
}
